import type React from 'react';

import { GlobalEventListenerRoot } from 'ui-components/components/global-event-listener/root';

import type { WorkflowStep, WorkflowEntityType } from '../../types';
import { TriggerEditor } from '../trigger-editor';
import styles from './styles.module.less';

type TriggerStepCardProps = {
  step: WorkflowStep;
  onUpdateStep: (step: WorkflowStep) => void;
  onEntityTypeChange: (entityType: WorkflowEntityType) => void;
};

export const TriggerStepCard: React.FC<TriggerStepCardProps> = ({ step, onUpdateStep, onEntityTypeChange }) => (
  <div className={styles.card} data-step-card>
    <GlobalEventListenerRoot>
      <TriggerEditor onEntityTypeChange={onEntityTypeChange} onUpdateStep={onUpdateStep} step={step} />
    </GlobalEventListenerRoot>
  </div>
);
